<template>
  <section class="section section_bg mobile_div pt-2 custom_page_v2" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <card class="loading_div section_black" v-if="isload==false">
      <h2>{{ load_message }}</h2>
    </card>

    <div class="" v-if="isload==true">
      <div class="container-fluid mobile_div">


        <div class="container-fluid mobile_div justify-content-center">



          <div class="row justify-content-center">

          <div class="d-flex justify-content-center col-12 col-md-6 col-lg-6">

          <div class="second_section mt-2 mb-2">
            <h2 class="d-flex justify-content-center">Настройки</h2>
            <p v-if="token_status" class="d-flex justify-content-center"><b class="mark">{{ token_balance }} {{ token_name}}</b></p>

            <p class="d-flex justify-content-center"><router-link to="/notify" class="btn m-2" >Уведомления <badge v-if="notify_count>0"
                type="danger">{{
                notify_count
              }}</badge></router-link></p>
            <p class="d-flex justify-content-center" v-if="isinvoices"><router-link class="btn m-2" to="/invoices" >Счета <badge v-if="notify_count_invoices>0"
                type="danger">{{
                notify_count_invoices
              }}</badge></router-link></p>

            <p class="d-flex justify-content-center" v-if="ismanual==true"><router-link class="btn m-2" to="/withdrawal" >Заявки на вывод
            </router-link></p>
            <p class="d-flex justify-content-center" v-if="verifications && verifications.length>0"><router-link class="btn m-2"  :to="{name:'setup_verifications'}" >Верификация</router-link></p>


            <p class="d-flex justify-content-center"><router-link class="btn m-2"  :to="{name:'setup'}" >Настройки профиля</router-link></p>
            <p class="d-flex justify-content-center" v-if="user.isdeveloper==1" ><router-link class="btn m-2" v-if="user.isdeveloper==1" to="/setup/developer" >Кабинет исполнителя</router-link></p>

            <p class="d-flex justify-content-center" v-if="user.isshop==1" ><router-link class="btn m-2" v-if="user.isshop==1" to="/setup/shop" >Кабинет поставщика</router-link></p>



            <p class="d-flex justify-content-center" v-if="isrewards==true"><router-link class="btn m-2"   :to="{name: 'rewards'}"
            >Награды
            </router-link></p>
            <p class="d-flex justify-content-center" v-if="user_agrement_link && user_agrement_link.length>1">

              <router-link  tag="a" class="btn m-2"
                  :to="{path: path_user_agrement_link}">Пользовательское<br>соглашение</router-link>
            </p>
            <p class="d-flex justify-content-center"><router-link class="btn m-2"   :to="{name: 'user_page_main', params: { user_id: user.last_id}}"
            >Ваш профиль
            </router-link></p>
            <p class="d-flex   text-center justify-content-center" v-if="isShowChangeTheme()"><button class="btn m-2" @click="changeTheme">Сменить тему<i  class="ni ni-air-baloon"></i></button></p>

            <p class="d-flex justify-content-center"> <button @click="this.Logout" class="btn"><i class="fa fa-user-secret"></i> Выход</button>
            </p>
          </div>
          </div>
          </div>


        </div>
      </div>

    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import TabPane from "@/components/Tabs/TabPane";
import UserModel from "../../models/UserModel";


export default {
  name: "SetupLinks",

  data() {
    var app = this;


    return {
      "notify_counts": {
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      'isrewards':true,
      'isinvoices':false,
      'ismanual':false,
      notify_count: 0,
      notify_count_invoices:0,
      notify_count_tasks:0,
      'token_name':null,
      'token_balance':null,
      'token_status':false,
      "load_message":"Идет загрузка..",
      'isload': false,
      'user': {},
      'verifications':[],
      "user_agrement_link":"",
      'path_user_agrement_link':''


    }
  },
  mounted() {


    var app = this;
    app.isload = false;
    app.user_agrement_link=Vue.config.USER_AGREMENT;
    var new_url=new URL(app.user_agrement_link);
    app.path_user_agrement_link=new_url.pathname;
    app.getUserData();









  },

  methods: {
    isShowChangeTheme(){
      if(window && window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initData){
        return false;
      }else {
        return true;
      }
    },
    changeTheme() {
      eventBus.$emit("changeTheme");

    },
    async getUserData(){
      var app=this;
      var user_data=await UserModel.getWithUpdate();
      app.user=user_data;


      Api.loadAccount(async function(data){
        app.ismanual=data.ismanual;
        app.isinvoices=data.isinvoices;
        app.isrewards=data.isrewards;
        app.verifications=data.verifications;
        app.token_status=data.token_status;
        app.token_name=data.token_name;
        app.token_balance=data.token_balance;

        app.isload=true;
      })
      if(app.user && app.user.last_id){


        app.updateNotifyCount();
      }

    },
    async updateNotifyCount() {

      var app = this;


      try{
        Api.loadNotifyCount(function (notifys) {


          app.notify_count = notifys.count;
          app.notify_count_invoices=notifys.count_invoices;
          app.notify_count_tasks=notifys.count_tasks;
          var total_count=app.notify_count+app.notify_count_invoices;
          app.total_count=total_count;

          var emit_params={};
          emit_params.notify_count=app.notify_count;
          emit_params.notify_count_invoices=app.notify_count_invoices;
          emit_params.notify_count_tasks=app.notify_count_tasks;
          eventBus.$emit("update_notify_count",emit_params)


        });
      } catch(e){

      }

      setTimeout(app.updateNotifyCount, 5000)


    },




  },
  components: {Tabs,Tab,TabPane,vueDropzone: vue2Dropzone,LoadingBlock}
};
</script>